var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 401,
    height: 522,
    viewBox: "0 0 401 522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#E9530D",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M334.484 130.063l-35.976 221.246c-2.195 13.468-13.824 23.363-27.473 23.363H130.32c-13.644 0-25.277-9.895-27.468-23.363L66.887 130.062h267.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.855 48.278V35.035C255.855 18.45 242.41 5 225.82 5h-50.28c-16.587 0-30.032 13.45-30.032 30.035v12.266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.871 47.3H97.488L13 130.064h375.36z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M226.543 425.074V517H174.82v-91.926M260.457 374.672v16.113c0 17.512-14.2 31.703-31.703 31.703h-56.14c-17.516 0-31.704-14.191-31.704-31.703v-16.113h119.547z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215 371.282V222h22.884M187 371.282V269.11h-24.516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.14 269.797V171.74h-39.898"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M162.2 270.465c0 11.738-9.516 21.254-21.255 21.254-11.738 0-21.254-9.516-21.254-21.254 0-11.738 9.516-21.25 21.254-21.25 11.739 0 21.254 9.512 21.254 21.25zM146.523 173.297c0 11.734-9.515 21.25-21.253 21.25-11.739 0-21.25-9.516-21.25-21.25 0-11.738 9.511-21.254 21.25-21.254 11.738 0 21.253 9.516 21.253 21.254zM281.668 221.469c0 11.738-9.516 21.254-21.254 21.254-11.734 0-21.25-9.516-21.25-21.254 0-11.739 9.516-21.254 21.25-21.254 11.738 0 21.254 9.515 21.254 21.254z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingLine);
export default __webpack_public_path__ + "static/media/lighting-line.19c1d95df13d0d4df83c8fee739c1669.svg";
export { ForwardRef as ReactComponent };